import React, { useContext, useEffect, useState } from 'react';

import AlertContext from '../../context/AlertContext';
import { AlertStyled } from '../../asset/styled/component/AlertStyled';

export const useAlert = () => {
  return useContext(AlertContext);
};

export const Alert = ({ alert, index }) => {
  const { alertActions } = useContext(AlertContext);
  const { removeAlert } = alertActions;

  const [hide, setHide] = useState(false);

  const handleToggle = () => {
    setHide(true);
    setTimeout(() => {
      removeAlert(alert.id);
      setHide(false);
    }, 500);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      handleToggle();
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleKeyDown = () => {
      handleToggle();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <AlertStyled style={{ zIndex: 2000 - index }} index={index} onClick={handleToggle}>
      <div className={`alertBox ${hide ? 'hide' : ''}`}>
        {typeof alert.value === 'string'
          ? alert.value.split(/\r?\n/).map((line, index, array) => {
              return (
                <React.Fragment key={`alert_${alert.id}_line_${index}_${Date.now()}`}>
                  {line}
                  {index < array.length - 1 && <br />}
                </React.Fragment>
              );
            })
          : alert.value}
      </div>
    </AlertStyled>
  );
};
